(function () {
  var recentlyViewedKey = 'mf-recently-viewed-v1';

  function storefrontRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function parseVariants(root) {
    var node = root.querySelector('[data-variants-json]');
    if (!node) return [];
    try {
      return JSON.parse(node.textContent || '[]');
    } catch (error) {
      return [];
    }
  }

  function renderStock(root, variant) {
    var status = root.querySelector('[data-stock-status]');
    var copy = root.querySelector('[data-stock-copy]');
    if (!status || !copy) return;

    var threshold = parseInt(root.getAttribute('data-threshold'), 10) || 5;
    var lowStock = variant.available && variant.inventoryTracked && variant.inventoryPolicy === 'deny' &&
      variant.inventoryQuantity > 0 && variant.inventoryQuantity <= threshold;
    status.classList.toggle('is-sold-out', !variant.available);
    status.classList.toggle('is-low-stock', lowStock);

    if (!variant.available) {
      copy.textContent = root.getAttribute('data-sold-out-label') || 'Sold out';
    } else if (lowStock) {
      var lowLabel = root.getAttribute('data-low-stock-label') || 'Only [count] left in stock';
      copy.textContent = lowLabel.replace(/\[count\]/g, String(variant.inventoryQuantity));
    } else {
      copy.textContent = root.getAttribute('data-in-stock-label') || 'In stock';
    }
  }

  function updateCartCount(cart) {
    var count = cart && cart.item_count;
    if (typeof count !== 'number') return;
    document.querySelectorAll('.mf-header__cart-count').forEach(function (badge) {
      badge.textContent = String(count);
      badge.classList.remove('animate-bump');
      void badge.offsetWidth;
      badge.classList.add('animate-bump');
    });
    document.querySelectorAll('.mf-header__cart').forEach(function (link) {
      link.setAttribute('aria-label', 'Cart, ' + count + ' items');
    });
  }

  function updateCartFromShopify() {
    return fetch(storefrontRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(updateCartCount)
      .catch(function () {});
  }

  function initCartForm(root) {
    var form = root.querySelector('.mf-product-form');
    var button = root.querySelector('[data-add-to-cart]');
    var feedback = root.querySelector('[data-cart-feedback]');
    var feedbackCopy = root.querySelector('[data-cart-feedback-copy]');
    var stickyLabel = root.querySelector('[data-sticky-button-label]');
    if (!form || !button || form.dataset.ajaxBound === 'true') return;

    form.dataset.ajaxBound = 'true';
    form.addEventListener('submit', function (event) {
      // Shopify's accelerated checkout uses its own submit/payment handoff.
      // Only intercept the regular add button; Shopify's accelerated checkout and native form fallbacks stay untouched.
      if (event.submitter !== button) return;
      if (!window.fetch || !window.FormData) return;

      event.preventDefault();
      if (button.disabled) return;
      var originalLabel = root.getAttribute('data-add-label') || button.dataset.addLabel || 'Add to Cart';
      button.disabled = true;
      button.classList.add('is-loading');

      fetch(storefrontRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      })
        .then(function (response) {
          return response.json().then(function (payload) {
            if (!response.ok) throw new Error(payload.description || payload.message || 'Could not add this item. Please try again.');
            return payload;
          });
        })
        .then(function () {
          if (feedbackCopy) feedbackCopy.textContent = root.getAttribute('data-added-label') || 'Added to Cart';
          if (feedback) feedback.hidden = false;
          var label = button.querySelector('[data-add-button-label]');
          var addedLabel = root.getAttribute('data-added-label') || 'Added to Cart';
          if (label) label.textContent = addedLabel;
          if (stickyLabel) stickyLabel.textContent = addedLabel;
          updateCartFromShopify();
          window.setTimeout(function () {
            if (label && button.isConnected) label.textContent = originalLabel;
            if (stickyLabel && button.isConnected) {
              stickyLabel.textContent = root._mfCanPurchase ? originalLabel : (button.dataset.soldOutLabel || 'Sold out');
            }
            if (feedback) feedback.hidden = true;
          }, 2600);
        })
        .catch(function (error) {
          if (feedbackCopy) feedbackCopy.textContent = error.message;
          if (feedback) feedback.hidden = false;
        })
        .finally(function () {
          button.classList.remove('is-loading');
          button.disabled = typeof root._mfCanPurchase === 'boolean' ? !root._mfCanPurchase : false;
        });
    });
  }

  function initProductTabs(root) {
    root.querySelectorAll('[data-product-tabs]').forEach(function (tabSet) {
      if (tabSet.dataset.tabsBound === 'true') return;
      tabSet.dataset.tabsBound = 'true';
      var tabs = Array.prototype.slice.call(tabSet.querySelectorAll('[data-product-tab]'));

      function activate(tab, moveFocus) {
        var panelId = tab.getAttribute('aria-controls');
        var panel = panelId && tabSet.querySelector('#' + panelId);
        if (!panel) return;
        tabs.forEach(function (candidate) {
          var active = candidate === tab;
          candidate.classList.toggle('is-active', active);
          candidate.setAttribute('aria-selected', active ? 'true' : 'false');
          candidate.setAttribute('tabindex', active ? '0' : '-1');
          var candidatePanel = tabSet.querySelector('#' + candidate.getAttribute('aria-controls'));
          if (candidatePanel) {
            candidatePanel.hidden = !active;
            candidatePanel.classList.toggle('is-active', active);
          }
        });
        if (moveFocus) tab.focus();
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () { activate(tab, false); });
        tab.addEventListener('keydown', function (event) {
          var nextIndex = index;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = tabs.length - 1;
          else return;
          event.preventDefault();
          activate(tabs[nextIndex], true);
        });
      });
    });
  }

  function initProduct(root) {
    if (!root || root.dataset.productPageReady === 'true') return;
    root.dataset.productPageReady = 'true';
    initProductTabs(root);

    var variants = parseVariants(root);
    var variantInput = root.querySelector('[data-variant-id]');
    var optionGroups = Array.prototype.slice.call(root.querySelectorAll('[data-option-group]'));
    var images = Array.prototype.slice.call(root.querySelectorAll('[data-product-image]'));
    var thumbnails = Array.prototype.slice.call(root.querySelectorAll('[data-product-thumbnail]'));
    var priceNode = root.querySelector('[data-current-price]');
    var compareNode = root.querySelector('[data-compare-price]');
    var savingsNode = root.querySelector('[data-savings-label]');
    var discountBadge = root.querySelector('[data-discount-badge]');
    var addButton = root.querySelector('[data-add-to-cart]');
    var dynamicCheckout = root.querySelector('.mf-dynamic-checkout');
    var stickyBar = root.querySelector('[data-sticky-buy]');
    var stickyAdd = root.querySelector('[data-sticky-add]');
    var mainActions = root.querySelector('[data-main-actions]');
    var productForm = root.querySelector('.mf-product-form');
    var quantity = root.querySelector('input[name="quantity"]');
    var sellingPlanField = root.querySelector('[data-selling-plan-field]');
    var sellingPlanSelect = root.querySelector('[data-selling-plan-select]');
    var activeMediaNumber = root.querySelector('[data-active-media-number]');
    var selectedVariant = variants.find(function (variant) {
      return variantInput && String(variant.id) === String(variantInput.value);
    }) || variants[0];

    function selectedOptions() {
      return optionGroups.map(function (group) {
        var active = group.querySelector('.mf-option-value.is-selected');
        return active ? active.getAttribute('data-option-value') : '';
      });
    }

    function setActiveMedia(mediaId) {
      if (!mediaId) return;
      var activeIndex = 0;
      images.forEach(function (image, index) {
        var active = image.getAttribute('data-media-id') === String(mediaId);
        image.classList.toggle('is-active', active);
        if (active) activeIndex = index + 1;
      });
      thumbnails.forEach(function (thumbnail) {
        var active = thumbnail.getAttribute('data-media-id') === String(mediaId);
        thumbnail.classList.toggle('is-active', active);
        thumbnail.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (activeMediaNumber && activeIndex) activeMediaNumber.textContent = String(activeIndex);
    }

    function syncOptionAvailability(options) {
      optionGroups.forEach(function (group, index) {
        group.querySelectorAll('.mf-option-value').forEach(function (button) {
          var candidate = button.getAttribute('data-option-value');
          var canExist = variants.some(function (variant) {
            if (variant.options[index] !== candidate) return false;
            return variant.options.every(function (value, optionIndex) {
              return optionIndex === index || !options[optionIndex] || value === options[optionIndex];
            });
          });
          button.disabled = !canExist;
          button.setAttribute('aria-disabled', canExist ? 'false' : 'true');
        });
      });
    }

    function renderVariantPrice(variant, allocation) {
      var displayedPrice = allocation ? allocation.price : variant.price;
      var compareAt = allocation ? allocation.compareAt : variant.compareAt;
      var displayedPriceValue = allocation ? allocation.priceValue : variant.priceValue;
      var compareAtValue = allocation ? allocation.compareAtValue : variant.compareAtValue;
      var hasDiscount = Number(compareAtValue) > Number(displayedPriceValue);
      var percent = hasDiscount
        ? Math.round(((Number(compareAtValue) - Number(displayedPriceValue)) / Number(compareAtValue)) * 100)
        : 0;

      if (priceNode) priceNode.textContent = displayedPrice;
      if (compareNode) {
        compareNode.textContent = compareAt || '';
        compareNode.classList.toggle('is-hidden', !compareAt);
      }
      if (savingsNode) {
        savingsNode.textContent = hasDiscount ? 'Save ' + percent + '%' : '';
        savingsNode.classList.toggle('is-hidden', !hasDiscount);
      }
      if (discountBadge) {
        discountBadge.textContent = hasDiscount ? 'Save ' + percent + '%' : '';
        discountBadge.hidden = !hasDiscount;
      }
      var stickyPrice = root.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = displayedPrice;
    }

    function updateSellingPlans(variant) {
      if (!sellingPlanSelect) return { available: true, allocation: null };
      var allocations = variant.sellingPlans || [];
      var previousValue = sellingPlanSelect.value;
      var requiresPlan = Boolean(variant.requiresSellingPlan);
      sellingPlanSelect.innerHTML = '';

      if (!requiresPlan) {
        var oneTime = document.createElement('option');
        oneTime.value = '';
        oneTime.textContent = 'One-time purchase';
        sellingPlanSelect.appendChild(oneTime);
      }

      allocations.forEach(function (allocation) {
        var option = document.createElement('option');
        option.value = String(allocation.id);
        option.textContent = allocation.name + (allocation.price ? ' - ' + allocation.price : '');
        sellingPlanSelect.appendChild(option);
      });

      var preserved = allocations.find(function (allocation) { return String(allocation.id) === previousValue; });
      if (preserved) sellingPlanSelect.value = previousValue;
      else if (requiresPlan && allocations.length) sellingPlanSelect.value = String(allocations[0].id);
      else sellingPlanSelect.value = '';

      if (sellingPlanField) sellingPlanField.hidden = allocations.length === 0 && !requiresPlan;
      sellingPlanSelect.disabled = allocations.length === 0;
      if (sellingPlanSelect.value) sellingPlanSelect.setAttribute('name', 'selling_plan');
      else sellingPlanSelect.removeAttribute('name');
      return {
        available: !requiresPlan || allocations.length > 0,
        allocation: allocations.find(function (allocation) { return String(allocation.id) === sellingPlanSelect.value; }) || null,
      };
    }

    function updateVariant(variant, options) {
      if (!variant) return;
      selectedVariant = variant;
      root._mfSelectedVariant = variant;
      if (variantInput) {
        variantInput.value = variant.id;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      optionGroups.forEach(function (group, index) {
        var value = options[index];
        var selectedLabel = group.querySelector('[data-selected-option]');
        if (selectedLabel) selectedLabel.textContent = value;
        group.querySelectorAll('.mf-option-value').forEach(function (button) {
          var active = button.getAttribute('data-option-value') === value;
          button.classList.toggle('is-selected', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      });
      syncOptionAvailability(options);

      var planState = updateSellingPlans(variant);
      renderVariantPrice(variant, planState.allocation);
      var canPurchase = variant.available && planState.available;
      root._mfCanPurchase = canPurchase;

      renderStock(root, variant);
      if (addButton) {
        addButton.disabled = !canPurchase;
        var addText = addButton.querySelector('[data-add-button-label]');
        if (addText) addText.textContent = canPurchase ? (addButton.dataset.addLabel || 'Add to Cart') : (addButton.dataset.soldOutLabel || 'Sold out');
      }
      if (dynamicCheckout) dynamicCheckout.hidden = !canPurchase;
      if (quantity) {
        var quantityIsBounded = variant.inventoryTracked && variant.inventoryPolicy === 'deny';
        if (quantityIsBounded) {
          quantity.max = String(Math.max(1, variant.inventoryQuantity));
          if (parseInt(quantity.value, 10) > variant.inventoryQuantity && variant.inventoryQuantity > 0) {
            quantity.value = String(variant.inventoryQuantity);
          }
        } else {
          quantity.removeAttribute('max');
        }
      }
      var stickyTitle = root.querySelector('[data-sticky-variant-title]');
      var stickyButton = root.querySelector('[data-sticky-button-label]');
      if (stickyTitle) stickyTitle.textContent = variant.title === 'Default Title' ? '' : variant.title;
      if (stickyButton) stickyButton.textContent = canPurchase ? (addButton.dataset.addLabel || 'Add to Cart') : (addButton.dataset.soldOutLabel || 'Sold out');
      if (stickyAdd) stickyAdd.disabled = !canPurchase;
      setActiveMedia(variant.mediaId);

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    if (selectedVariant) {
      updateVariant(selectedVariant, selectedVariant.options);
    }

    optionGroups.forEach(function (group, index) {
      group.addEventListener('click', function (event) {
        var button = event.target.closest('.mf-option-value');
        if (!button || button.disabled) return;
        var options = selectedOptions();
        options[index] = button.getAttribute('data-option-value');
        var match = variants.find(function (variant) {
          return variant.options.every(function (value, optionIndex) { return value === options[optionIndex]; });
        });
        if (match) updateVariant(match, options);
      });
    });

    if (sellingPlanSelect) {
      sellingPlanSelect.addEventListener('change', function () {
        if (!selectedVariant) return;
        var selectedPlan = (selectedVariant.sellingPlans || []).find(function (allocation) {
          return String(allocation.id) === sellingPlanSelect.value;
        });
        renderVariantPrice(selectedVariant, selectedPlan || null);
      });
    }

    thumbnails.forEach(function (thumbnail) {
      thumbnail.addEventListener('click', function () {
        setActiveMedia(thumbnail.getAttribute('data-media-id'));
      });
    });

    root.querySelectorAll('[data-gallery-step]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (!images.length) return;
        var activeIndex = images.findIndex(function (image) { return image.classList.contains('is-active'); });
        if (activeIndex < 0) activeIndex = 0;
        var step = parseInt(button.getAttribute('data-gallery-step'), 10) || 1;
        var nextIndex = (activeIndex + step + images.length) % images.length;
        var nextImage = images[nextIndex];
        setActiveMedia(nextImage.getAttribute('data-media-id'));
        var thumb = root.querySelector('[data-product-thumbnail][data-media-id="' + nextImage.getAttribute('data-media-id') + '"]');
        if (thumb && thumb.scrollIntoView) thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      });
    });

    root.querySelectorAll('[data-quantity-step]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (!quantity) return;
        var value = (parseInt(quantity.value, 10) || 1) + parseInt(button.getAttribute('data-quantity-step'), 10);
        var max = parseInt(quantity.max, 10);
        quantity.value = String(Math.max(1, Number.isFinite(max) ? Math.min(max, value) : value));
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    var zoomDialog = root.querySelector('[data-zoom-dialog]');
    var zoomImage = root.querySelector('[data-zoom-image]');
    var zoomTrigger = root.querySelector('[data-open-zoom]');
    var lastFocusedElement = null;
    function closeZoom() {
      if (zoomDialog && zoomDialog.open) zoomDialog.close();
      if (lastFocusedElement && lastFocusedElement.focus) lastFocusedElement.focus();
    }
    if (zoomDialog && zoomImage && zoomTrigger) {
      zoomTrigger.addEventListener('click', function () {
        var activeImage = root.querySelector('[data-product-image].is-active');
        if (!activeImage) return;
        lastFocusedElement = document.activeElement;
        zoomImage.src = activeImage.getAttribute('data-zoom-src') || activeImage.currentSrc || activeImage.src;
        zoomImage.alt = activeImage.alt;
        if (typeof zoomDialog.showModal === 'function') zoomDialog.showModal();
      });
      root.querySelector('[data-close-zoom]').addEventListener('click', closeZoom);
      zoomDialog.addEventListener('click', function (event) {
        if (event.target === zoomDialog) closeZoom();
      });
    }

    initCartForm(root);

    if (stickyBar && mainActions && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var shouldShow = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        if (shouldShow) {
          stickyBar.hidden = false;
          stickyBar.setAttribute('aria-hidden', 'false');
          window.requestAnimationFrame(function () { stickyBar.classList.add('is-visible'); });
        } else {
          stickyBar.classList.remove('is-visible');
          stickyBar.setAttribute('aria-hidden', 'true');
          window.setTimeout(function () {
            if (!stickyBar.classList.contains('is-visible')) stickyBar.hidden = true;
          }, 230);
        }
      }, { threshold: 0.08 });
      observer.observe(mainActions);
      if (stickyAdd && addButton) {
        stickyAdd.addEventListener('click', function () {
          if (stickyAdd.disabled) return;
          if (productForm && typeof productForm.requestSubmit === 'function') productForm.requestSubmit(addButton);
          else addButton.click();
        });
      }
    }

    initRecommendations(root);
    initRecentlyViewed(root);
  }

  function initRecommendations(scope) {
    var recommendationSections = [];
    if (scope && scope.matches && scope.matches('[data-product-recommendations]')) recommendationSections.push(scope);
    if (scope && scope.querySelectorAll) {
      recommendationSections = recommendationSections.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-product-recommendations]')));
    }
    recommendationSections.forEach(function (section) {
      if (section.dataset.loaded === 'true') return;
      section.dataset.loaded = 'true';
      var query = new URLSearchParams({
        product_id: section.getAttribute('data-product-id'),
        limit: section.getAttribute('data-limit') || '4',
        section_id: section.getAttribute('data-section-id'),
        intent: section.getAttribute('data-intent') || 'related',
      });
      fetch(storefrontRoot() + 'recommendations/products?' + query.toString(), { headers: { Accept: 'text/html' } })
        .then(function (response) { return response.ok ? response.text() : ''; })
        .then(function (html) {
          if (!html) return;
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var returnedSection = parsed.getElementById('MFProductRecommendations-' + section.getAttribute('data-section-id'));
          var returnedContent = returnedSection && returnedSection.querySelector('[data-recommendation-content]');
          var content = section.querySelector('[data-recommendation-content]');
          if (!returnedContent || !content || !returnedContent.children.length) return;
          content.innerHTML = returnedContent.innerHTML;
          section.hidden = false;
        })
        .catch(function () {});
    });
  }

  function formatPrice(cents) {
    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
      ? window.Shopify.currency.active
      : 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency }).format(Number(cents) / 100);
    } catch (error) {
      return (Number(cents) / 100).toFixed(2);
    }
  }

  function createRecentlyViewedCard(product) {
    var link = document.createElement('a');
    link.className = 'mf-recent-card';
    link.href = storefrontRoot() + 'products/' + encodeURIComponent(product.handle);

    var image = document.createElement('img');
    image.loading = 'lazy';
    image.alt = product.title || '';
    image.src = product.featured_image || (product.images && product.images[0]) || '';
    link.appendChild(image);

    var info = document.createElement('span');
    info.className = 'mf-recent-card__info';
    var title = document.createElement('span');
    title.className = 'mf-recent-card__title';
    title.textContent = product.title || '';
    var price = document.createElement('span');
    price.className = 'mf-recent-card__price';
    price.textContent = formatPrice(product.price);
    info.appendChild(title);
    info.appendChild(price);
    link.appendChild(info);
    return link;
  }

  function initRecentlyViewed(root) {
    var section = root.querySelector('[data-recently-viewed]');
    if (!section) return;

    var currentHandle = section.getAttribute('data-current-handle');
    var limit = parseInt(section.getAttribute('data-limit'), 10) || 4;
    var viewed = [];
    try {
      var stored = JSON.parse(window.localStorage.getItem(recentlyViewedKey) || '[]');
      if (Array.isArray(stored)) viewed = stored.filter(function (handle) { return typeof handle === 'string' && handle !== currentHandle; });
      window.localStorage.setItem(recentlyViewedKey, JSON.stringify([currentHandle].concat(viewed).slice(0, 10)));
    } catch (error) {
      return;
    }

    var grid = section.querySelector('[data-recently-viewed-grid]');
    if (!grid || viewed.length === 0) return;
    Promise.all(viewed.slice(0, limit).map(function (handle) {
      return fetch(storefrontRoot() + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.ok ? response.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      products.filter(function (product) { return product && product.handle; }).forEach(function (product) {
        grid.appendChild(createRecentlyViewedCard(product));
      });
      if (grid.children.length) section.hidden = false;
    });
  }

  function initAll(scope) {
    var roots = [];
    if (scope && scope.matches && scope.matches('[id^="MFProduct-"]')) roots.push(scope);
    if (scope && scope.querySelectorAll) roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll('[id^="MFProduct-"]')));
    roots.forEach(initProduct);
    initRecommendations(scope);
  }

  initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();